<template>
  <base-card
    v-if="EntityCardMixin_CopySource"
    :title="EntityCardMixin_Title"
  >
    <v-row>
      <base-field
        v-if="EntityCardMixin_CopySource.dateStart"
        v-model="EntityCardMixin_CopySource.dateStart"
        base-field-container-type="v-col"
        base-field-type="date"
        :disabled="EntityCardMixin_Disabled"
        :label="TextMixin_GetLabel('dateStart')"
        :readonly="EntityCardMixin_Readonly"
      />
    </v-row>
  </base-card>
</template>

<script>
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'EntityCardMonitorsDetailExtraInformation',
  mixins: [
    EntityCardMixin
  ],
  mounted () {
    this.Initialize()
  },
  methods: {
    Initialize () {
      this.EntityCardMixin_SetDefaultTitle('extraInformation')
    }
  }
}
</script>
